import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MngHotkey } from '../mng-hotkeys.types';
import { UpperCasePipe } from '@angular/common';
import { LayoutAlignDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';

@Component({
  selector: 'mng-hotkey',
  imports: [LayoutDirective, LayoutAlignDirective, UpperCasePipe],
  templateUrl: './mng-hotkey.component.html',
  styleUrl: './mng-hotkey.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MngHotkeyComponent {
  @Input() hotkey: MngHotkey;
}
